import { Button, Checkbox, Icon, Select, Switch, TimePicker } from 'antd';
import cn from 'classnames';
import moment from 'moment';
import React from 'react';

import {
  defaultIntervalFrom,
  defaultIntervalTo,
  intervalRepeatModes,
  intervalWeekdayOptions,
  timeFormat,
} from '../../constants';
import styles from '../../ScheduleCalendar.module.scss';

const { Option } = Select;

export const IntervalAssignmentPanel = ({
  canAssignIntervalToActivePerformer,
  canAssignIntervals,
  canClearIntervals,
  canSaveIntervals,
  intervalFrom,
  intervalTo,
  isIntervalAssignmentChanged,
  isManualIntervalAssignment,
  isMassAssignmentEnabled,
  repeatMode,
  selectedWeekdays,
  onApplyIntervalToActivePerformer,
  onAssignIntervalsToAll,
  onBackIntervals,
  onCancelIntervals,
  onClearAllIntervals,
  onIntervalFromChange,
  onIntervalToChange,
  onMassAssignmentChange,
  onRepeatModeChange,
  onSaveIntervals,
  onWeekdayChange,
}) => (
  <div className={styles.intervalAssignment}>
    <div className={styles.intervalAssignmentHeader}>
      <div className={styles.intervalAssignmentTitle}>
        <Icon type="download" />
        <span>Массовое назначение интервалов</span>
      </div>
      <Switch
        checked={isManualIntervalAssignment ? false : isMassAssignmentEnabled}
        disabled={isManualIntervalAssignment}
        onChange={onMassAssignmentChange}
      />
    </div>

    <div className={styles.intervalAssignmentHint}>
      <div className={styles.intervalAssignmentHintIcon}>
        <Icon type="info-circle" />
      </div>
      <div>
        {isManualIntervalAssignment
          ? 'Настройте интервал и нажмите на ячейку календаря, чтобы назначить его на выбранную дату.'
          : isMassAssignmentEnabled
          ? 'Настройте интервал и дни, затем примените его ко всем выбранным исполнителям.'
          : 'Настройте интервал и дни, выберите исполнителя в календаре, затем примените интервал. Очистка удалит интервалы только выбранного исполнителя.'}
      </div>
    </div>

    <div className={styles.intervalAssignmentTimeRow}>
      <span className={styles.intervalAssignmentLabel}>Рабочее время</span>
      <div className={styles.intervalAssignmentTimeFields}>
        <TimePicker
          allowClear={false}
          className={styles.intervalAssignmentTimePicker}
          format={timeFormat}
          minuteStep={5}
          value={moment(intervalFrom || defaultIntervalFrom, timeFormat)}
          onChange={(_value, timeString) => onIntervalFromChange(timeString)}
        />
        <span className={styles.intervalAssignmentTimeSeparator}>—</span>
        <TimePicker
          allowClear={false}
          className={styles.intervalAssignmentTimePicker}
          format={timeFormat}
          minuteStep={5}
          value={moment(intervalTo || defaultIntervalTo, timeFormat)}
          onChange={(_value, timeString) => onIntervalToChange(timeString)}
        />
      </div>
    </div>

    <div className={styles.intervalAssignmentRepeat}>
      <div className={styles.intervalAssignmentSettings}>
        <span className={styles.intervalAssignmentLabel}>
          Способ назначения
        </span>
        <Select
          className={styles.intervalAssignmentRepeatSelect}
          value={repeatMode}
          onChange={onRepeatModeChange}
        >
          <Option value={intervalRepeatModes.manual}>Вручную по датам</Option>
          <Option value={intervalRepeatModes.weekly}>
            Повторять по неделям
          </Option>
        </Select>
      </div>
      <div className={styles.intervalAssignmentWeekdays}>
        {intervalWeekdayOptions.map((weekday) => (
          <label
            key={weekday.value}
            className={cn(styles.intervalWeekday, {
              [styles.intervalWeekday_disabled]: isManualIntervalAssignment,
            })}
          >
            <Checkbox
              checked={selectedWeekdays.includes(weekday.value)}
              disabled={isManualIntervalAssignment}
              onChange={() => onWeekdayChange(weekday.value)}
            />
            <span>{weekday.label}</span>
          </label>
        ))}
      </div>
    </div>

    <div className={styles.intervalAssignmentActions}>
      <Button
        className={styles.intervalAssignmentClear}
        disabled={!canClearIntervals}
        onClick={onClearAllIntervals}
      >
        Очистить все
      </Button>
      <Button
        type="primary"
        className={styles.intervalAssignmentApply}
        disabled={
          isManualIntervalAssignment
            ? true
            : isMassAssignmentEnabled
            ? !canAssignIntervals || !isIntervalAssignmentChanged
            : !canAssignIntervalToActivePerformer ||
              !isIntervalAssignmentChanged
        }
        onClick={
          isMassAssignmentEnabled
            ? onAssignIntervalsToAll
            : onApplyIntervalToActivePerformer
        }
      >
        {isMassAssignmentEnabled ? 'Применить всем' : 'Применить'}
      </Button>
      <Button
        icon="left"
        className={styles.intervalAssignmentBack}
        onClick={onBackIntervals}
      >
        Назад к настройкам
      </Button>
      <Button
        className={styles.intervalAssignmentCancel}
        onClick={onCancelIntervals}
      >
        Отмена
      </Button>
      <Button
        type="primary"
        className={styles.intervalAssignmentSave}
        disabled={!canSaveIntervals}
        onClick={onSaveIntervals}
      >
        Сохранить
      </Button>
    </div>
  </div>
);
